module.exports = __webpack_public_path__ + "static/media/example.969944e4.gif";